import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';
import { type Locale, LOCALE_US } from 'dibs-intl/exports/locales';

const SPONSORED_LABEL_AB_TEST_NAME = 'SL_NewLabeling_April2026';

export const getSponsoredLabelAbTestVariant = (): string | null | undefined => {
    return getAbTestV2(SPONSORED_LABEL_AB_TEST_NAME)?.variant;
};

let hasTrackingFired = false;
export const trackSponsoredLabelAbTestVariant = (locale: Locale): void => {
    if (locale !== LOCALE_US) {
        return;
    }
    if (!hasTrackingFired) {
        trackAbTestV2Variant(SPONSORED_LABEL_AB_TEST_NAME);
        hasTrackingFired = true;
        return;
    }
};
